<template>
  <ModalWrapper
    class="z-header-overlay"
    @close-modal="$emit('close')"
  >
    <div class="p-24 pt-32">
      <div>
        {{ $lang('seller', 'external_products_removed') }} 
      </div>
      <ButtonComponent
        is-block
        :is-secondary-btn="true"
        class="w-full mt-16"
        :text="$lang('seller', 'ok')"
        @click="$emit('close')"
      />
    </div>
  </ModalWrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ModalWrapper from '~/components/global/ModalWrapper.vue';
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
export default defineComponent({
  components: { ButtonComponent, ModalWrapper },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
});
</script>
